import ServiceTemplate from '@/components/ServiceTemplate';

export default function CCorporation() {
  const data = {
    title: 'C Corporation Formation',
    subtitle: 'Establish your C Corporation with expert guidance and complete compliance.',
    overviewTitle: 'Why Choose a C Corporation?',
    overviewImage: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf',
    description: [
      'A C Corporation is a traditional corporate structure ideal for businesses seeking outside investment, planning significant growth, or requiring complex ownership structures. C Corps offer strong liability protection and unlimited growth potential.',
      'C Corporations are separate legal entities that can issue multiple classes of stock, making them attractive to investors and venture capital. They provide maximum flexibility for raising capital.',
      'Our comprehensive C Corporation formation service handles all filing requirements, prepares necessary corporate documents, and ensures compliance with state and federal regulations.'
    ],
    benefits: [
      { title: 'Unlimited Growth', description: 'No restrictions on number or types of shareholders.' },
      { title: 'Investment Ready', description: 'Attractive to venture capital and institutional investors.' },
      { title: 'Multiple Stock Classes', description: 'Issue different classes of stock with varying rights.' },
      { title: 'Strong Liability Protection', description: 'Separate legal entity shields personal assets.' },
      { title: 'Perpetual Existence', description: 'Corporation continues regardless of ownership changes.' },
      { title: 'Employee Benefits', description: 'Offer favorable stock options and benefits programs.' }
    ],
    process: [
      { title: 'Discovery & Planning', description: 'Comprehensive assessment of your needs and strategic planning for optimal outcomes.' },
      { title: 'Documentation & Filing', description: 'Complete preparation and filing of all required documents with appropriate authorities.' },
      { title: 'Compliance & Support', description: 'Ongoing compliance monitoring, support, and strategic guidance as your needs evolve.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential formation',
        price: '$299',
        period: '+ state fees',
        features: [
          'Entity formation filing',
          'Name availability check',
          'EIN application',
          'Basic documents',
          'Email support',
          'Document delivery'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete package',
        price: '$599',
        period: '+ state fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Custom agreements',
          'Tax consultation',
          'Compliance setup',
          'Registered agent (1 year)',
          'Priority processing',
          'Phone support'
        ]
      },
      {
        name: 'Enterprise',
        description: 'Full-service solution',
        price: '$999',
        period: '+ state fees',
        features: [
          'Everything in Professional',
          'Multi-state filing',
          'Advanced structuring',
          'Annual compliance',
          'Quarterly reviews',
          'Dedicated attorney',
          'Unlimited consultations'
        ]
      }
    ],
    faqs: [
      { question: 'What is double taxation?', answer: 'C Corporations pay corporate tax on profits, and shareholders pay personal tax on dividends, creating two levels of taxation.' },
      { question: 'How many shareholders can I have?', answer: 'C Corporations have no limit on the number or type of shareholders, making them ideal for large businesses.' },
      { question: 'Can I convert from LLC to C Corp?', answer: 'Yes, LLCs can convert to C Corporations, though tax implications should be carefully evaluated.' },
      { question: 'What are ongoing requirements?', answer: 'Annual reports, corporate meetings, meeting minutes, and proper corporate record-keeping are required.' },
      { question: 'Do I need a board of directors?', answer: 'Yes, C Corporations must have a board of directors, though small corporations can have a single director/shareholder.' },
      { question: 'How is a C Corp different from S Corp?', answer: 'C Corps have no ownership restrictions and face double taxation, while S Corps have pass-through taxation but more limitations.' },
      { question: 'Can I raise venture capital with a C Corp?', answer: 'Yes, C Corporations are the preferred structure for venture capital and institutional investment.' },
      { question: 'What is the cost to form a C Corporation?', answer: 'State filing fees range from $100-$500, plus our service fees and ongoing compliance costs.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
